import React from 'react';
import styles from './index.module.less';
import { DeliveryStatus } from '../../api/models/deliveries';
import classnames from 'classnames';

type StepsStatusProps = {
  status: DeliveryStatus;
};

const StepsStatus = ({ status }: StepsStatusProps) => {
  const redDropoff = status === DeliveryStatus.CNF || status === DeliveryStatus.Cancelled;
  const isDelivered = status === DeliveryStatus.Delivered;
  return (
    <div className={styles.stepsContainer}>
      <div className={styles.circlePickupIcon} />
      <div className={classnames([styles.line, isDelivered ? styles.solid : undefined])} />
      <div className={classnames([styles.circleDropoffIcon, redDropoff ? styles.danger : undefined])} />
    </div>
  );
};

export default StepsStatus;
